module.exports = __webpack_public_path__ + "media/pages/assets/images/gallery/2021/april-cc7a8dd3ad88e7545ef2e9f9114a5b78.png";